import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { firebaseApp } from 'firebaseConfig';
import useKeystoreStorageHelpers from 'utils/helpers/keystoreStorage.helpers';

// Keystore access goes through Firebase Storage rules, so it needs Firebase signed in as this user
// (UID = SAVI user id). Not needed when keystore calls are routed through the API.
export const useFirebaseReadyForUser = (userId?: string): boolean => {
  const { gcpNetworkBlocked } = useKeystoreStorageHelpers();
  const [firebaseUid, setFirebaseUid] = useState(() => getAuth(firebaseApp).currentUser?.uid);

  useEffect(() => onAuthStateChanged(getAuth(firebaseApp), firebaseUser => setFirebaseUid(firebaseUser?.uid)), []);

  return !!userId && (gcpNetworkBlocked || firebaseUid === userId);
};
